import { set } from 'date-fns';

export function dateStringToDate(date: string): Date {
  const [year, month, day] = date.split('-').map(Number);

  return set(new Date(), {
    year,
    month: month - 1,
    date: day,
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });
}
